import { apiClient } from '@/lib/api-client';

// Sprint 38 + Feedback Functionality sprint — Feedback feature client.
// Mirrors C-Back-End/src/feedback/feedback.controller.ts.

export type FeedbackType = 'SUGGESTION' | 'BUG';
export type FeedbackSeverity = 'LOW' | 'MEDIUM' | 'HIGH' | 'CRITICAL';
export type FeedbackStatus = 'NEW' | 'TRIAGED' | 'IN_PROGRESS' | 'DONE' | 'REJECTED';

export const MAX_FEEDBACK_ATTACHMENTS = 5;
export const MAX_FEEDBACK_ATTACHMENT_BYTES = 5 * 1024 * 1024;
/** MIME types accepted by the file picker and runtime guard (must match BE). */
export const FEEDBACK_ATTACHMENT_ACCEPT =
  'image/png,image/jpeg,image/jpg,image/webp,image/gif,application/pdf';
export const FEEDBACK_ATTACHMENT_MIME_ALLOWLIST = new Set(
  FEEDBACK_ATTACHMENT_ACCEPT.split(',').map((s) => s.trim()).filter(Boolean),
);

export interface FeedbackSubmissionInput {
  type: FeedbackType;
  title: string;
  description: string;
  severity?: FeedbackSeverity;
  screenshotUrl?: string;
  attachmentIds?: string[];
  // Auto-captured at submit time:
  pageUrl?: string;
  userAgent?: string;
  viewport?: string;
  appVersion?: string;
  metadata?: Record<string, unknown>;
}

export interface MyFeedbackItem {
  id: string;
  type: FeedbackType;
  title: string;
  severity: FeedbackSeverity | null;
  status: FeedbackStatus;
  createdAt: string;
  attachmentCount?: number;
  latestAnalysis: {
    classification: string;
    summary: string;
    suggestedActionJson: {
      type: string;
      rationale: string;
      estimatedEffort: string;
    };
    createdAt: string;
  } | null;
}

export const feedbackApi = {
  submit: (input: FeedbackSubmissionInput) =>
    apiClient.post<{ id: string; status: FeedbackStatus }>('/feedback', input),

  myList: () =>
    apiClient.get<{ items: MyFeedbackItem[] }>('/me/feedback'),
};
